/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import CTAs from 'components/shared/ctas/ctas';
import Button from 'components/shared/button/button';
import Skip from 'components/shared/skip/skip_container';
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import { pageurl } from 'utils/environment';
// STYLES
import styles from 'components/content/userdatacollection/phases/udcfailure/udcfailure_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, { link:false });



/* ========== ~~~~~~~~~~ SER DATA COLLECTION SUCCESS PHASE: CHILD ~~~~~~~~~~ ========== */
class UDCFailurePhase extends Component {
    constructor(props) {
        super(props);
        this.timeoutId = null;
        this.state = { loaded: false };
    }

    componentWillUnmount() {
        this.props.showLoader(false);
    }

    handleTryAgain = () => {
        clearTimeout(this.timeoutId);
        this.props.setUniqueState(this.props.contentId, { phase: 'entry' });
    };

    processSkip = () => {
        this.props.showLoader(true);
        this.props.submitUDCData(this.props.contentId, this.getUDCData(), this.props.isPubPortalPreview, null)
    };

    getUDCData = () => {
        const { userId, embedUUID, udcId, contentSignature } = this.props;
        return {
            cookieId: userId,
            contentUUID: udcId,
            contentType: 'user_data_collection',
            pageUrl: pageurl,
            embedUUID,
            contentSignature,
            contentProperties: { engagementType: 'SKIP' }
        }
    };

    render() {
        return (
            <div className={`${sheet.classes.udcfailure} uniquecontent ${this.props.phase}`}>
                <div className={`failuremessage`}>
                    <div className={`graphic failure`} />
                    <Title>{`Whoops!`}</Title>
                    <BodyCopy>
                        <p>{`A temporary server error has occurred. Please try again.`}</p>
                    </BodyCopy>
                </div>
                <CTAs type={`block`}>
                    <Button klass={`white`} onClick={this.handleTryAgain}>{`Try again`}</Button>
                    <Skip contentId={this.props.contentId}
                          styleType={'transparent'}
                          next={false}
                          trackingEvent={'embedUDCSkipClicked'}
                          bypassSettings={true}
                          onSkip={this.processSkip}
                    />
                </CTAs>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UDCFailurePhase;
